import React from "react";
import { useHistory } from "react-router-dom";

import { Grid } from "@material-ui/core";
import { Form, Formik } from "formik";
import * as yup from "yup";

import Button from "../../components/Button";
import logo from "../../assets/images/logo.svg";
import Logo from "../../components/Logo";
import Paper from "../../components/Paper";
import Background from "../../components/Background";
import Disclaimer from "../../components/Disclaimer";
import { LoginTextField } from "../../components/LoginTextField";
import { errorCodes } from "../../constants/errors";
import { saveNewPassword } from "../../api/password";
import { routes } from "../../api/paths";
import MetaDecorator from "../../components/MetaDecorator";

const passwordSchema = yup.object({
  password: yup
    .string()
    .required("Upišite lozinku.")
    .matches(
      /^.*(?=.{8,})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      "Lozinka mora sadržavati najmanje 8 znakova, barem jedan broj i barem jedno veliko slovo."
    ),
  confirmPassword: yup
    .string()
    .required("Upišite lozinku.")
    .oneOf([yup.ref("password"), null], "Lozinke moraju biti jednake."),
});

type PasswordSetupProps = {
  token: string | null;
};

export default function PasswordSetup({ token }: PasswordSetupProps) {
  const history = useHistory();

  return (
    <>
      <MetaDecorator />
      <Background>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={8} lg={3}>
            <Paper>
              <Logo src={logo} />
              <Disclaimer>
                Napomena: lozinka mora sadržavati najmanje 8 znakova, barem
                jedan broj i barem jedno veliko slovo.
              </Disclaimer>
              <Formik
                initialValues={{ password: "", confirmPassword: "" }}
                validationSchema={passwordSchema}
                onSubmit={async (values) => {
                  try {
                    await saveNewPassword(values.password, token);
                    history.push(routes.PASSWORD_UPDATED_URL);
                  } catch (error: any) {
                    if (
                      error.response &&
                      error.response.status === errorCodes.NOT_FOUND
                    ) {
                      history.push(routes.ACCESS_DENIED_URL);
                    } else if (
                      error.response &&
                      error.response.status === errorCodes.UNAUTHORIZED
                    ) {
                      history.push(routes.EXPIRED_TOKEN_URL);
                    }
                  }
                }}
              >
                {({ handleSubmit }) => (
                  <Form onSubmit={handleSubmit}>
                    <LoginTextField
                      id="password"
                      label="Unesite lozinku"
                      name="password"
                      type="password"
                    />
                    <LoginTextField
                      id="confirmPassword"
                      label="Ponovno unesite lozinku"
                      name="confirmPassword"
                      type="password"
                    />
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Potvrdi
                    </Button>
                  </Form>
                )}
              </Formik>
            </Paper>
          </Grid>
        </Grid>
      </Background>
    </>
  );
}
